export default __webpack_public_path__ + "static/media/header-img.41e16cf5.png";